import type { Hunt } from './types';

/** The first part picked up. Same pink as a multi-part scan location. */
export const FIRST_PART_COLOR = '#ff4fa3';
/** The parts still to be found. */
export const REMAINING_PART_COLOR = '#e5252a';

export interface HuntDot {
  lat: number;
  lng: number;
  color: string;
  /** Text for the dot's tooltip panel. */
  label: string;
}

export interface HuntLine {
  from: { lat: number; lng: number };
  to: { lat: number; lng: number };
}

export interface HuntShapes {
  dots: HuntDot[];
  lines: HuntLine[];
}

/**
 * What to draw for a set of hunts: a pink dot at each first part, a red dot at each part still
 * to find, and a line from the first part to each of those. A hunt with no decodable first part
 * has no lines, since there is nothing to join them to.
 */
export function huntShapes(hunts: Hunt[]): HuntShapes {
  const dots: HuntDot[] = [];
  const lines: HuntLine[] = [];
  for (const h of hunts) {
    const first = h.first;
    if (first) {
      dots.push({ lat: first.lat, lng: first.lng, color: FIRST_PART_COLOR, label: `${h.itemName}: ${first.partName} (first part, picked up)` });
    }
    for (const p of h.remaining) {
      dots.push({ lat: p.lat, lng: p.lng, color: REMAINING_PART_COLOR, label: `${h.itemName}: ${p.partName} (not yet found)` });
      if (first) lines.push({ from: { lat: first.lat, lng: first.lng }, to: { lat: p.lat, lng: p.lng } });
    }
  }
  return { dots, lines };
}
